import axios from 'axios';
import Cookies from 'js-cookie';

// instância utilizada apenas para realizar o login e obter o token jwt
export const LoginApi = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  }
});

export const Api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  }
});

export const ApiDashboard = Api;

// Interceptador de token nas requisições da instância Api
Api.interceptors.request.use(async (config: any) => {
  try {
    const token = Cookies.get("TOKEN_JWT"); // Obtém o token do cookie

    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch (error) {
    console.error("Error retrieving token:", error);
  }

  return config;
});
